import styled from "styled-components";
import { Link } from "react-router-dom";

export const FooterSection = styled("footer")`
  background: #333333;
  padding: 2.5rem 0;
`;

export const Title = styled("h4")`
  font-size: 18px;
  font-weight: 600;
  text-transform: capitalize;
  color: #ffffff;
  margin-bottom: 1rem;
  margin-top: 0;

  @media screen and (max-width: 414px) {
    padding: 1.5rem 0;
  }
`;

export const NavLink = styled(Link)`
  display: block;
  font-size: 1rem;
  margin-bottom: 0.625rem;
  transition: all 0.2s ease-in-out;

  &:hover,
  &:active,
  &:focus {
    color: #ffffff;
  }
`;

export const Extra = styled("section")`
  background: #333333;
  position: relative;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding: 1rem 0 2rem 0;
  text-align: center;
`;


export const Para = styled("div")`
  color: #ffffff;
  font-size: 14px;
  margin: 0 auto;
`;

export const Large = styled(Link)`
  font-size: 14px;
  color: #cccccc;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  line-height: 28px;
  display: block;
  margin-bottom: 0.5rem;
  transition: all 0.3s ease-in-out;
  max-width: max-content;
  text-decoration: none;

  &:hover {
    color: rgb(255, 130, 92);
  }
`;


export const Chat = styled("p")`
  color: #ffffff;
  max-width: fit-content;
  border-bottom: 1px solid #ffffff;
  cursor: pointer;
  margin-top: 1rem;
  transition: all 0.3s ease-in-out;

  &:hover {
    border-bottom: 1px solid rgb(255, 130, 92);
    color: rgb(255, 130, 92);
  }
`;

export const Empty = styled("div")`
  position: relative;
  height: 53px;
`;

export const FooterContainer = styled("div")`
  max-width: 510px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  text-align: center;
  align-items: center;
  transition: all 0.1s ease-in-out;

  a {
    &:hover,
    &:active,
    &:focus {
      -webkit-transform: scale(1.1);
      -ms-transform: scale(1.1);
      transform: scale(1.1);
    }
  }

  @media screen and (max-width: 769px) {
    width: auto;

    a:not(:last-child) {
      display: none;
    }
  }

  div {
    cursor: pointer;
    margin-right: 15px;
    width: 25px;
    height: 25px;

    &:hover {
      fill: rgb(255, 130, 92);
    }
  }
`;

export const Language = styled("h4")`
  font-size: 22px;
  text-transform: capitalize;
  color:rgb(0, 0, 0);

  @media screen and (max-width: 414px) {
    padding: 1.5rem 0;
  }
`;

export const Label = styled("label")`
  font-size: 22px;
  text-transform: capitalize;
  color:rgb(0, 0, 0);
  display: block;
  margin-bottom: 2rem;
  font-family: "Inter Bold", sans-serif;

  @media screen and (max-width: 414px) {
    padding: 1.5rem 0;
    margin-bottom: 1rem;
  }
`;

export const LanguageSwitch = styled("div")`
  cursor: pointer;
  transition: all 0.1s ease-in-out;

  &:hover,
  &:active,
  &:focus {
    -webkit-transform: scale(1.1);
    -ms-transform: scale(1.1);
    transform: scale(1.1);
  }
`;

export const LanguageSwitchContainer = styled("div")`
  display: flex;
  justify-content: space-between;
  width: 85px;
`;